import { Field, InputType } from 'type-graphql'

@InputType()
export class BasicAuthForgetPasswordArgs {
  @Field(() => String)
  username: string

  @Field(() => String)
  recaptchaToken: string

  @Field(() => String)
  validTill: string //Why there is a need for this.....
}
